import React, { useEffect, useState } from "react";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface CasesCompletingGoalsTableState {
  data: any;
}

export const CasesCompletingGoalsTable = ({ data }: CasesCompletingGoalsTableState): React.JSX.Element | null => {
  const [casesCompletingGoals, setCasesCompletingGoals] = useState<any[]>([]);

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "Goals Completed", key: "goals_completed" },
  ];

  useEffect(() => {
    if (data) {
      const { goals } = data;
      const completingCases = uniqueCasesWithCompletedGoals(goals);
      setCasesCompletingGoals(completingCases);
    }
  }, [data]);

  const uniqueCasesWithCompletedGoals = (sortedGoals: any[]) =>
    Object.values(
      sortedGoals
        .filter((g: any) => g.completed_at)
        .reduce((acc: any, g: any) => {
          if (acc[g.case_id]) {
            acc[g.case_id].goals_completed++;
          } else {
            acc[g.case_id] = { case_id: g.case_id, case_name: g.case_name, goals_completed: 1 };
          }
          return acc;
        }, {}),
    );

  return casesCompletingGoals ? (
    <DataTable tableHeadings={tableHeaders} tableData={casesCompletingGoals} title={"Cases Completing Goals"} />
  ) : (
    loadingCard()
  );
};
